class AuthToken {
   static value;
}

export default new AuthToken;
